import { Controller } from 'stimulus';
import { templateContent } from '@/js/util';

export default class extends Controller {
  static values = {
    targetId: String,
    uniqueId: String,
  };

  append() {
    // Another entry point may have placed this slide already; let it own it.
    if (this.#alreadyMoved) {
      this.element.remove();
      return;
    }

    const content = templateContent(this.element);
    this.target.appendChild(content);
    this.element.remove();
  }

  get #alreadyMoved() {
    return Boolean(this.uniqueIdValue) && Boolean(document.getElementById(this.uniqueIdValue));
  }

  get target() {
    const target = document.getElementById(this.targetIdValue);
    if (!target) {
      throw new Error(`Cannot locate container #${this.targetIdValue}`);
    }
    return target;
  }
}
